module.exports = __webpack_public_path__ + "img/06_g.51e97fa4.webp";